import React, { useEffect, useState, useContext } from "react";
import {
  ProgressBar,
  Form,
} from "react-bootstrap";
import { Utils, UserContext } from "./../../common";
import { useLocation } from "react-router-dom";
import moment from "moment";

import MessageModal from "./../../components/MessageModal";

const Login = (props) => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(false);
  const [switchTo, setSwitchTo] = useState(1); // 1 for login view, 2 for forgot password view
  const [askOTP, setAskOTP] = useState(false);
  const [email, setEmail] = useState("");
  const [eyeMode, setEyeMode] = useState(0);

  const { goLogin, goFrgpwd, goImpersonate } = useContext(UserContext);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const usr = queryParams.get("usr");
  const mode = queryParams.get("mode");

  const impersonateMe = (success, message) => {
    if (success) {
      window.setTimeout(function () {
        //console.log(Utils.getUserData());
        window.location.href = process.env.PUBLIC_URL + "/dashboard";
      }, 100);
    } else {
      window.alert(message);
    }
  };

  useEffect(() => {
    if (mode === "impersonate" && usr !== "") {
      goImpersonate({ email: usr }, impersonateMe);
    } else if (Utils.isLoggedIn()) {
      window.location.href = process.env.PUBLIC_URL + "/dashboard";
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [otpTimer, setOtpTimer] = useState(0);
  const [otpTimerTracker, setOtpTimerTracker] = useState(null);

  useEffect(() => {
    if (otpTimer > 0) {
      setOtpTimerTracker(
        window.setTimeout(() => {
          setOtpTimer(otpTimer - 1);
        }, 1000),
      );
    } else if (otpTimerTracker) {
      window.clearTimeout(otpTimerTracker);
      setOtpTimerTracker(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [otpTimer]);

  const resendOTP = (e) => {
    setOtpTimer(0);
    setLoading(true);
    goFrgpwd({ email: email }, (success, message) => {
      setLoading(false);
      setMessage([success ? "success" : "error", message]);
      if (success) {
        setOtpTimer(600);
      }
    });
  };

  const submit = (e) => {
    var frm = e.currentTarget;
    e.preventDefault();
    var data = {
      email: frm.email.value,
    };

    if (switchTo === 1) {
      data["password"] = frm.password.value;
    } else if (askOTP) {
      data["new_password"] = frm.new_password.value;
      data["otp"] = frm.otp.value;

      if (frm.new_password.value !== frm.conf_password.value) {
        setMessage(["error", "New Passwords not matching."]);
        return false;
      }
    } else {
      setEmail(data.email);
    }

    setLoading(true);
    (switchTo === 1 ? goLogin : goFrgpwd)(data, authCallback);
  };

  let authCallback = (success, message) => {
    setLoading(false);
    setMessage([success ? "success" : "error", message]);
    if (success) {
      if (switchTo === 1) {
        window.setTimeout(function () {
          //console.log(Utils.getUserData());
          window.location.href = process.env.PUBLIC_URL + "/dashboard";
        }, 100);
      } else {
        if (askOTP) {
          setOtpTimer(0);
          setAskOTP(false);
          setSwitchTo(1);
        } else {
          console.log("start otp counter");
          setAskOTP(true);
          setOtpTimer(600);
        }
      }
    }
  };

  const getEyeSrc = () => {
    let em = [
      `${process.env.PUBLIC_URL}/EyeClosed.png`,
      `${process.env.PUBLIC_URL}/EyeOpen.png`,
    ];
    return em[eyeMode ? 1 : 0];
  };

  return (
    <div style={{ minHeight: "100vh", background: "var(--paper)", display: "flex", alignItems: "center", justifyContent: "center", padding: "24px 16px" }}>
      {mode !== "impersonate" && (
        <div style={{ maxWidth: "440px", width: "100%" }}>
          <div className="card shadow border-0" style={{ borderRadius: "20px", overflow: "hidden", background: "#FFFFFF", boxShadow: "0 10px 30px rgba(24, 16, 89, 0.08)" }}>
            
            {/* Clean Brand Header */}
            <div style={{ background: "linear-gradient(135deg, #181059 0%, #221875 100%)", padding: "32px 24px 28px", textAlign: "center" }}>
              <div style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", background: "#FFFFFF", padding: "8px 18px", borderRadius: "12px", boxShadow: "0 4px 14px rgba(0,0,0,0.15)", marginBottom: "12px" }}>
                <img src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="DenTTrack" style={{ maxHeight: "32px", maxWidth: "160px", objectFit: "contain" }} />
              </div>
              <h2 style={{ color: "#FFFFFF", fontFamily: "var(--display)", fontSize: "20px", fontWeight: 800, margin: "6px 0 2px", letterSpacing: "-0.02em" }}>
                {switchTo === 1 ? "Workplace Portal" : "Reset Password"}
              </h2>
              <p style={{ color: "#BFD5EF", fontSize: "13px", margin: 0 }}>
                {switchTo === 1 ? "Sign in to your practice account" : "Enter your email to receive a reset OTP"}
              </p>
            </div>

            {/* Form Body */}
            <div style={{ padding: "32px 28px" }}>
              {message && (
                <MessageModal
                  type={message[0]}
                  message={message[1]}
                  onHide={() => {
                    setMessage(false);
                  }}
                />
              )}

              {loading && (
                <div className="p-4 text-center my-3 bg-light rounded">
                  <ProgressBar variant="primary" animated now={100} style={{ height: 6 }} />
                  <p className="mt-2 text-muted small fw-semibold">Authenticating...</p>
                </div>
              )}

              {!loading && (
                <Form onSubmit={submit}>
                  <Form.Group className="mb-3">
                    <Form.Label className="small fw-bold text-muted text-uppercase" style={{ fontSize: "11px", letterSpacing: "0.05em" }}>
                      Email Address
                    </Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      placeholder="name@practice.co.uk"
                      defaultValue={email}
                      required
                      readOnly={askOTP}
                      style={{ padding: "10px 14px", borderRadius: "9px", border: "1.5px solid var(--line)", fontSize: "14px" }}
                    />
                  </Form.Group>

                  {switchTo === 2 && askOTP && (
                    <>
                      <Form.Group className="mb-3">
                        <Form.Label className="small fw-bold text-muted text-uppercase" style={{ fontSize: "11px", letterSpacing: "0.05em" }}>
                          Enter OTP Code
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="otp"
                          placeholder="XXXXXX"
                          required
                          style={{ padding: "10px 14px", borderRadius: "9px", border: "1.5px solid var(--line)", fontSize: "14px" }}
                        />
                      </Form.Group>

                      <div className="d-flex justify-content-between align-items-center mb-3 small">
                        <div>
                          {otpTimer > 0 && (
                            <span className="text-muted">
                              Expires in: <strong style={{ color: "var(--mint)" }}>{moment().minutes(0).seconds(otpTimer).format("mm:ss")}</strong>
                            </span>
                          )}
                          {otpTimer <= 0 && <strong style={{ color: "var(--coral)" }}>OTP Expired!</strong>}
                        </div>
                        <span className="text-primary clickable fw-bold" onClick={resendOTP} style={{ cursor: "pointer" }}>
                          Resend OTP
                        </span>
                      </div>

                      <Form.Group className="mb-3">
                        <Form.Label className="small fw-bold text-muted text-uppercase" style={{ fontSize: "11px", letterSpacing: "0.05em" }}>
                          New Password
                        </Form.Label>
                        <Form.Control
                          type="password"
                          name="new_password"
                          placeholder="••••••••"
                          required
                          style={{ padding: "10px 14px", borderRadius: "9px", border: "1.5px solid var(--line)", fontSize: "14px" }}
                        />
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label className="small fw-bold text-muted text-uppercase" style={{ fontSize: "11px", letterSpacing: "0.05em" }}>
                          Confirm New Password
                        </Form.Label>
                        <Form.Control
                          type="password"
                          name="conf_password"
                          placeholder="••••••••"
                          required
                          style={{ padding: "10px 14px", borderRadius: "9px", border: "1.5px solid var(--line)", fontSize: "14px" }}
                        />
                      </Form.Group>
                    </>
                  )}

                  {switchTo === 1 && (
                    <Form.Group className="mb-3">
                      <div className="d-flex justify-content-between align-items-center mb-1">
                        <Form.Label className="small fw-bold text-muted text-uppercase m-0" style={{ fontSize: "11px", letterSpacing: "0.05em" }}>
                          Password
                        </Form.Label>
                        <span
                          className="clickable small fw-semibold"
                          onClick={() => setSwitchTo(2)}
                          style={{ color: "var(--dt-action)", cursor: "pointer", fontSize: "12px" }}
                        >
                          Forgot password?
                        </span>
                      </div>
                      <div className="position-relative">
                        <Form.Control
                          type={eyeMode ? "text" : "password"}
                          name="password"
                          placeholder="••••••••"
                          required
                          style={{ padding: "10px 42px 10px 14px", borderRadius: "9px", border: "1.5px solid var(--line)", fontSize: "14px" }}
                        />
                        <span
                          onClick={() => setEyeMode(!eyeMode)}
                          style={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", cursor: "pointer", color: "var(--muted)" }}
                        >
                          <img src={getEyeSrc()} alt="toggle" style={{ width: 18, height: 18, opacity: 0.6 }} />
                        </span>
                      </div>
                    </Form.Group>
                  )}

                  {switchTo === 2 && (
                    <div className="mb-3 text-end">
                      <span
                        className="clickable small fw-semibold"
                        onClick={() => setSwitchTo(1)}
                        style={{ color: "var(--dt-action)", cursor: "pointer", fontSize: "13px" }}
                      >
                        Back to Login
                      </span>
                    </div>
                  )}

                  <button
                    type="submit"
                    className="dt-btn dt-btn--primary w-100 py-2.5 mt-2"
                    style={{ fontSize: "14px", height: "46px" }}
                  >
                    {switchTo === 1 ? "Sign In →" : (askOTP ? "Confirm New Password" : "Send Recovery OTP")}
                  </button>
                </Form>
              )}
            </div>

            <div className="p-3 text-center border-top bg-light">
              <span className="small text-muted d-block mb-2" style={{ fontSize: "12px" }}>Are you a dental trainee or CPD student?</span>
              <button
                type="button"
                className="dt-btn dt-btn--ghost w-100 py-2"
                onClick={() => window.open("https://training.denttrack.co.uk/auth?no_redirect", "_blank")}
                style={{ fontSize: "12.5px", fontWeight: 700, border: "1px solid #CBD5E1", background: "#FFFFFF", color: "var(--dt-navy)" }}
              >
                🎓 Open Student CPD Portal
              </button>
              <div className="mt-2 text-muted" style={{ fontSize: "11px" }}>
                DenTTrack &bull; Clinical Practice Governance
              </div>
            </div>
          </div>
        </div>
      )}
      {mode === "impersonate" && <h1>Requesting to Impersonate user {usr}</h1>}
    </div>
  );
};

export default Login;
